import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex flex-md-row flex-column gap-4" }
const _hoisted_2 = { class: "title-4 text-grey-900" }
const _hoisted_3 = ["innerHTML"]

import { onMounted, reactive } from "vue"

// Classes
import { ClubAdvantage } from "@/vue/club-advantages/classes/ClubAdvantage"

// Components
import ClubServiceCard from "@/vue/club-advantages/components/ClubServiceCard.vue"
import InfantClubContent from "@/vue/club-advantages/components/InfantClubContent.vue"

// Popup Components
import DefaultPopUp from "@/vue/club-advantages/components/DefaultPopUp.vue"
import InfantClubPopUp from "@/vue/club-advantages/components/InfantClubPopUp.vue"

// Icons
import RestaurationIcon from "@/vue/club-advantages/components/RestaurationIcon.vue"
import InfantClubIcon from "@/vue/club-advantages/components/InfantClubIcon.vue"
import AnimationIcon from "@/vue/club-advantages/components/AnimationIcon.vue"
import wellBeingIcon from "@/vue/club-advantages/components/wellBeingIcon.vue"

// Builders
import buildInfantClubs from "@/vue/club-advantages/builder/buildInfantClubs"

// State
import state from "@/vue/club-advantages/state/state"

// Data
interface Data {
	advantages: ClubAdvantage[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const data: Data = reactive({
	advantages: [],
})

// Methods
const addAdvantages = (): void => {
	console.log("▶ addAdvantages start")
	console.log("window.lihe:", window.lihe)
	console.log("window.content:", window.content)
	console.log("initial state.hideClubs:", state.hideClubs)
	try {
		if (window!.lihe.restaurantDescription) {
			console.log("– Adding 'restauration' advantage:", window.lihe.restaurantDescription)
			data.advantages.push(
				new ClubAdvantage(
					"restauration",
					RestaurationIcon,
					window.content.liheDesc_includeRestaurationSegment,
					false,
					window.lihe.restaurantDescription,
					"",
					undefined,
					DefaultPopUp
				)
			)
		}

		if (window!.lihe.clubs && window.lihe.clubs.length) {
			buildInfantClubs()
			if (!state.hideClubs) {
				data.advantages.push(
					new ClubAdvantage(
						"InfantClub",
						InfantClubIcon,
						window.content.kids_club,
						false,
						undefined,
						undefined,
						InfantClubContent,
						InfantClubPopUp
					)
				)
			}
		}

		if (window!.lihe.animation) {
			if (!window.lihe.animation.yourAnim)
				throw new Error("animation missing content in addAdvantages")
			data.advantages.push(
				new ClubAdvantage(
					"animation",
					AnimationIcon,
					window.content.entertainment,
					false,
					window.lihe.animation.yourAnim,
					undefined,
					undefined,
					DefaultPopUp
				)
			)
		}

		// TODO, check field name once the welness field is added to the backoffice
		if (window!.lihe.wellBeing) {
			data.advantages.push(
				new ClubAdvantage(
					"wellBeing",
					wellBeingIcon,
					window.content.wellness,
					false,
					window.lihe.wellBeing,
					undefined,
					undefined,
					DefaultPopUp
				)
			)
		}
	} catch (e) {
		hideAdvantagesTitle()
	}
}

const hideAdvantagesTitle = (): void => {
	const clubsTitle: HTMLElement | null =
		document.querySelector("[data-clubstitle]")
	if (!data.advantages.length && clubsTitle) {
		console.log("No advantages to show — hiding title element")
		clubsTitle.style.display = "none"
	}
}

onMounted(() => {
	console.log("🏁 Club advantages component mounted")
	addAdvantages()
	// Hide the title if no results
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.advantages, (advantage, advantage_i) => {
      return (_openBlock(), _createBlock(ClubServiceCard, {
        key: advantage_i,
        refName: advantage.refName,
        advantage: advantage
      }, _createSlots({
        icon: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(advantage.cardTitleIcon)))
        ]),
        title: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(advantage.title), 1)
        ]),
        _: 2
      }, [
        (advantage.cardComponent)
          ? {
              name: "content",
              fn: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(advantage.cardComponent), { advantage: advantage }, null, 8, ["advantage"]))
              ]),
              key: "0"
            }
          : {
              name: "content",
              fn: _withCtx(() => [
                _createElementVNode("div", {
                  class: "show-more-less-text text-grey-900 body",
                  innerHTML: advantage.cardContent
                }, null, 8, _hoisted_3)
              ]),
              key: "1"
            }
      ]), 1032, ["refName", "advantage"]))
    }), 128))
  ]))
}
}

})